import theme from '../../../../../../components/ui-kit/themes/theme';
import { Text } from '../../../../../ui-kit';
import { SummaryContent } from '../../../Content';
import useLodgeData from '../../../../../../hooks/ui_hooks/useLodgeData';
import * as COPY from '../../utilities/copy';
import { editCopyByReplaceString } from '../../../../../utilities/copyFunctions';

const ParkingFee = () => {
  const { resortDailyParkingFee } = useLodgeData();
  return (
    <>
      {resortDailyParkingFee ? (
        <SummaryContent.Item id="BookingSummaryParkingFee">
          <Text
            textAlign="left"
            fontWeight={theme.fontWeights.medium}
            color="deepLakeBlue.100"
            fontSize={0}
            lineHeight="16px">
            {editCopyByReplaceString(COPY.DAILY_PARKING_FEE, resortDailyParkingFee, '<FEE>')}
          </Text>
        </SummaryContent.Item>
      ) : null}
    </>
  );
};

export default ParkingFee;
